import { useEffect, useState } from "react";
import api from "../../utils/axiosInstance";
import FormSelect from "../Form/FormSelect";
import { toast } from "../Toast/toast";
import { btn } from "../Button/buttonStyles";
import { PAYMENT_PARTIES, methodLabel } from "./paymentParties";

// Changes which payment method a recorded payment went through. Vendor payments
// choose from that vendor's own methods, client payments from the account's.
const PaymentMethodEditor = ({ party, payment, currentId, onSaved, onCancel }) => {
  const config = PAYMENT_PARTIES[party];
  const [methods, setMethods] = useState([]);
  const [value, setValue] = useState(currentId ?? "");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api
      .get(config.methodsUrl(payment), { withCredentials: true })
      .then(({ data }) => setMethods(config.pickMethods(data.data)))
      .catch(() => toast.error("Could not load the payment methods."))
      .finally(() => setLoading(false));
  }, [config, payment]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(
        `${config.endpoint}/${payment.id}`,
        { payment_method_id: value ? Number(value) : null },
        { withCredentials: true }
      );
      toast.success("Payment method updated.");
      onSaved(data.data);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to update the payment method.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="px-5 py-4 space-y-3 max-w-md">
      <FormSelect
        label="Payment method"
        name="payment_method_id"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        options={methods.map((m) => ({ value: m.id, label: methodLabel(m) }))}
        placeholder={loading ? "Loading..." : methods.length ? undefined : "No payment methods are set up"}
        disabled={loading || saving}
      />
      <div className="flex gap-2">
        <button onClick={handleSave} disabled={loading || saving} className={btn("primary", "sm")}>
          {saving ? "Saving..." : "Save"}
        </button>
        <button onClick={onCancel} disabled={saving} className={btn("secondary", "sm")}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default PaymentMethodEditor;
